
export enum RagUploadStatus {
	INITIAL = "INITIAL",
	PROGRESS = "PROGRESS",
	COMPLETED = "COMPLETED",
	FAILED = "FAILED"
}
